const getFieldList = ({ requiredFieldsList, section, subSection }) => {
  const selectedSection = requiredFieldsList[section];
  const subSectionKeys = Object.keys(selectedSection?.children);
  const hasSubSection = subSectionKeys.length !== 0;
  const subSectionList = ["self", ...subSectionKeys];
  const targetFieldList =
    hasSubSection && subSection !== "self" ? selectedSection?.children[subSection].fields : selectedSection?.fields;

  return {
    subSectionList,
    targetFieldList,
    hasSubSection,
  };
};

export { getFieldList };
